import { PipeTransform } from '@angular/core';
import * as moment from 'moment';
var FromNowPipe = /** @class */ (function () {
    function FromNowPipe() {
    }
    /**
     * @param date in format 'DD-MM-YYYY HH:mm'
     * @returns humanized duration as example: "3 minutes from now"
     */
    FromNowPipe.prototype.transform = function (date) {
        return moment(date).fromNow();
    };
    return FromNowPipe;
}());
export { FromNowPipe };
